<template>
  <div
    v-if="selectedFutureOccasions.length"
    class="selected-future-occasions"
  >
    <h2 class="title is-5">
      You have selected the following reminders:
    </h2>
    <ul>
      <li
        v-for="(occasion, index) in selectedFutureOccasions"
        :key="index"
      >
        <strong>{{ occasion.period | numberWithCommas }} {{ occasion.dateType }}</strong>
      </li>
    </ul>
  </div>
  <p v-else>
    You haven't selected any reminders yet :(
  </p>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'SelectedOccasionsList',
  computed: mapState([
    'selectedFutureOccasions',
  ]),
}
</script>
